import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from "framer-motion";
import { Sling as Hamburger } from 'hamburger-react';
import { useNavigate } from "react-router-dom";


import logo from '../assets/img/logo.webp'
import logoBlack from '../assets/img/logo_black.webp'
import { MdOutlineHome, MdOutlineLightMode } from 'react-icons/md';
import { Helmet } from 'react-helmet';

import { TfiHome } from "react-icons/tfi";

function calculateHamburger(width) {
    if (width < 1300) return 18;
    return 21;
}

const NavLogin = ({
    isScrolled,
}) => {
    const [isOpen, setOpen] = useState(false);
    const [hamburgerSize, setHamburgerSize] = useState(() => calculateHamburger(window.innerWidth));

    useEffect(() => {
        const handleResize = () => setHamburgerSize(calculateHamburger(window.innerWidth));
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const menuRef = useRef(null);
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/"); // Navigate to homepage

        setTimeout(() => {
            const homeSection = document.getElementById("home");
            if (homeSection) {
                const offset = 20; // Adjust scroll offset
                const targetY = homeSection.getBoundingClientRect().top + window.scrollY - offset;

                window.scrollTo({ top: targetY, behavior: "smooth" });
            }
        }, 100); // Delay ensures the page loads before scrolling
    };

    const toggleOpen = () => {
        setOpen(prevState => !prevState);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    const fadeInMenu = {
        initial: {
            opacity: 0,
            maxHeight: 0, // Start with height 0
            // y: 10, // Small upward motion
        },
        animate: {
            opacity: 1,
            maxHeight: "5rem", // Expand to full height
            // y: 0,
            transition: {
                ease: "easeInOut",
                duration: 0.5,
            }
        },
        exit: {
            opacity: 0,
            maxHeight: 0, // Collapse height back to 0
            // y: 10,
            transition: {
                ease: "easeInOut",
                duration: 0.4, // Slightly faster collapse
            }
        }
    };


    return (
        <div>
            <Helmet>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "WebSite",
                            "name": "Murage Juma & Company Advocates",
                            "url": "https://jncmlaw.co.ke",
                            "description": "Dedicated to Justice, Driven by Integrity",
                            "publisher": {
                                "@type": "Organization",
                                "name": "Murage Juma & Company Advocates",
                                "logo": "https://jncmlaw.co.ke/logo512.png",
                            },
                        }),
                    }}
                />
                {/* <title>Murage Juma & Company Advocates</title> */}
                <meta name="description" content='Dedicated to Justice, Driven by Integrity' />
                <meta name="author" content="Designed by Mutai" />
                <meta name="publisher" content="Designed by Mutai" />
                <meta name="robots" content="index, follow" />
                <meta name="google-site-verification" content="mmxN3C8BY0isfRqwrpBiUKir_kx3CnHvOHQcRDrw9Ic" />
                <meta name="keywords" content="joseph murage, joe murage, joseph nicholas Murage, josé murage, juma kagoro, john patrick machira, law firm, law associates, kenya law, kenya lawyers, kenyan law firm, murage juma & company advocates, commissioners for oaths, notaries public, agri business, agri, debt collection, succession law, intellectual property law, sale of property, sale of assets, family law, civil litigation, commercial litigation, natural resource law research, energy and natural resource law research, legal entity formation, securities perfection, banking securities, project finance securities, Civil and Commercial Litigation, Immigration Law Advisory and Ancillary Services" />
                <meta name="robots" content="index, follow" />

                {/* Open Graph (Facebook, LinkedIn) */}
                <meta property="og:title" content="Murage Juma & Company Advocates" />
                <meta property="og:description" content="Dedicated to Justice, Driven by Integrity" />
                <meta property="og:site_name" content="Murage Juma & Company Advocates" />
                <meta property="og:image" content="%PUBLIC_URL%/og-image.jpg" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:url" content='https://jncmlaw.co.ke/' />
                <meta property="og:type" content="website" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Murage Juma & Company Advocates" />
                <meta name="twitter:description" content="Dedicated to Justice, Driven by Integrity" />
                <meta name="twitter:image" content="%PUBLIC_URL%/twitter-image.jpg" />

            </Helmet>
            <div
                className='relative w-full'
            >
                <div
                    className='fixed top-0 flex items-center justify-center w-full xs:h-[4.5rem] md:h-[5rem] xl:h-[5rem] 2xl:h-[6rem]'
                >
                    <div className={`trns500 xs:left-0 xs:w-screen lg:w-[92.5%] xl:w-[90%] 2xl:w-[85%] 4xl:w-[77.5%] mx-auto flex flex-row items-center xs:h-[4.5rem] md:h-[5rem] lg:h-[4rem] xl:h-[4.75rem] 2xl:h-[6rem] xs:backdrop-blur-[6px] md:backdrop-blur-[12px] lg:backdrop-blur-[16px] xs:border-[1.5px] 2xl:border-[3px] border-white/0 md:-mt-0 ${isScrolled ? `bg-gradient-to-b from-white via-white/80 to-white/60 shadow-2xl border-white ${isOpen ? 'rounded-b-[0px]' : 'rounded-b-[12px]'}` : 'bg-gradient-to-r from-gray-100/0 via-gray-100/80 to-gray-100/0 shadow-none'}`}>
                        <div className={`relative z-[900] ${isScrolled ? 'opacity-80' : 'opacity-100'}`}>
                            <AnimatePresence mode="wait">
                                <motion.img
                                    onClick={handleClick}
                                    key={isScrolled ? "scrolledLogo" : "defaultLogo"}
                                    src={isScrolled ? logoBlack : logo}
                                    className={`cursor-pointer object-contain xs:w-[3.5rem] xsp:w-[3.75rem] md:w-[4.5rem] lg:w-[3.25rem] xl:w-[3.75rem] 2xl:w-[5rem] h-auto xs:ml-[0.25rem] xl:ml-[0.5rem]`}
                                    alt="Murage Juma & Company Advocates"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.5 }}
                                />
                            </AnimatePresence>
                        </div>
                        <div
                            className='xs:w-[75%] lg:w-[50%] xs:leading-[0.65rem] xsp:leading-[0.75rem] md:leading-[0.95rem] lg:leading-[0.75rem] xl:leading-[0.85rem] 2xl:leading-[1rem] xs:pl-[0.75rem] lg:pl-[1rem] 2xl:pl-[1.5rem] rennerMed uppercase h-full flex flex-col items-start justify-center'
                        >
                            <h1
                                className={`trns500 xs:text-[0.5rem] xsp:text-[0.625rem] md:text-[0.75rem] lg:text-[0.5rem] xl:text-[0.6rem] 2xl:text-[0.675rem] xs:tracking-[1.5px] md:tracking-[2px] xl:tracking-[2.5px] 2xl:tracking-[3px] ${isScrolled ? 'text-slate-700' : 'text-primaryBlue'}`}
                            >
                                Murage Juma &amp; Company Advocates
                            </h1>
                            <h2
                                className={`trns500 xs:text-[0.4rem] xsp:text-[0.5rem] md:text-[0.6rem] lg:text-[0.425rem] xl:text-[0.525rem] 2xl:text-[0.6rem] xs:tracking-[1.25px] md:tracking-[1.5px] xl:tracking-[1.75px] 2xl:tracking-[1.85px] ${isScrolled ? 'text-slate-500' : 'text-primaryGreen'}`}
                            >
                                Commissioners for Oaths &amp; Notaries Public
                            </h2>
                        </div>
                        <div
                            ref={menuRef}
                            className='relative xs:w-[25%] lg:w-[50%] z-[9999] flex items-center justify-end h-full py-[1.5rem] lg:py-[1rem] 2xl:py-[2rem] rennerBold text-primaryBlue uppercase tracking-[2px] xs:text-[0.5rem] sm:text-[0.55rem] lg:text-[0.6rem] xl:text-[0.65rem] 2xl:text-[0.7rem] xs:pr-[0.25rem] lg:pr-[0.5rem] 2xl:pr-[0.5rem]'
                        >
                            <button
                                // onClick={() => navigate("/")}
                                onClick={handleClick}
                                className={`trns500 group absolute z-[1000] cursor-pointer flex items-center justify-center alata btnTxtSize tracking-[0px] text-white/90 hover:text-black xs:w-[3rem] xs:h-[3rem] xsp:w-[3.5rem] xsp:h-[3.5rem] lg:w-[3rem] lg:h-[3rem] xl:w-[3.5rem] xl:h-[3.5rem] 2xl:w-[4rem] 2xl:h-[4rem] rounded-full mx-auto xs:border-[3px] 2xl:border-[4px] border-slate-200/95 hover:border-slate-200 shadow-2xl xs:outline-[3px] 2xl:outline-[4px] outline-white/50 hover:outline-slate-900/80 btnTxtShadow ${isScrolled ? 'bg-slate-700 border-slate-800/50 hover:bg-slate-900 outline-slate-800/0 hover:outline-slate-900' : 'bg-gradient-to-br from-primaryRichBlue to-primaryRichGreen outline-primaryRichGreen/0 hover:outline-primaryRichGreen'}`}
                            >
                                <MdOutlineHome className={`trns500 text-white xs:text-[1.25rem] md:text-[1.5rem] lg:text-[1.25rem] 2xl:text-[1.5rem] ${isScrolled ? '' : 'group-hover:text-black'}`} />
                            </button>
                            {/* <div
                                className='xs:hidden lg:flex relative z-[900] w-[8rem] group cursor-pointer h-full flex-row items-center justify-center border-r border-primaryGreen'
                            >
                                Light
                                <MdOutlineLightMode
                                    className='trns500 rotate-0 transform group-hover:rotate-[240deg] xs:text-[0.85rem] lg:text-[1.25rem] xs:ml-[0.5rem] lg:ml-[1rem] text-primaryGreen'
                                />
                            </div>
                            <div
                                className='cursor-pointer flex flex-row items-center justify-end lg:w-[8rem] xs:gap-x-[0rem] lg:gap-x-[0.25rem] xl:gap-x-[0.5rem] xs:-mt-[5px] md:-mt-0'
                            >
                                <span
                                    onClick={toggleOpen}
                                    className={`xs:-mr-[5px] md:-mr-0 ${isOpen ? 'text-red-800' : ''}`}
                                >
                                    {isOpen ? 'Close' : 'Menu'}
                                </span>
                                <Hamburger
                                    onClick={toggleOpen}
                                    toggle={setOpen}
                                    rounded={true}
                                    size={hamburgerSize}
                                    easing="ease-in-out"
                                    distance="lg"
                                    duration={0.5}
                                    toggled={isOpen}
                                    color={`${isOpen ? 'hsl(0, 80%, 40%)' : 'hsl(182, 56%, 45%)'}`}
                                />
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className={`trns500 fixed w-full h-[10px] xs:mt-[4.5rem] md:mt-[5rem] xl:mt-[5rem] 2xl:mt-[6rem] ${isScrolled ? 'opacity-0' : 'opacity-100'}`}>
                    <div className='h-[1px] xs:w-full lg:w-[90%] xl:w-[87.5%] 2xl:w-[85%] 4xl:w-[77.5%] mx-auto bg-gradient-to-r from-primaryLightBlue to-primaryLightGreen' />
                </div>
                <AnimatePresence mode='wait'>
                    {isOpen && (
                        <motion.div
                            className='w-full flex justify-center'
                            key={isOpen}
                            variants={fadeInMenu}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                        >
                            <div
                                className='bg-gradient-to-b from-slate-50 to-slate-100/60 xs:p-[2px] 2xl:p-[4px] xs:w-full lg:w-[90%] xl:w-[87.5%] 2xl:w-[85%] xs:h-auto lg:h-[4.5rem] xl:h-[5.5rem] xs:top-[4.5rem] xl:top-[5rem] 2xl:top-[6rem] fixed shadow-2xl rounded-b-[12px] backdrop-blur-[8px]'
                            >
                                <div className={`trns500 overflow-hidden w-full h-full bg-gradient-to-r from-menuBlue to-menuGreen rounded-b-[8px] lg:py-0 menuShadow ${isOpen ? 'lg:max-h-[6rem] opacity-100' : 'max-h-0 opacity-0'}`}>
                                    <ul
                                        className='relative z-[9999] alata text-white/90 txtShadow xs:flex xs:flex-col lg:flex-row lg:inline-flex items-center justify-center xs:space-y-[0rem] lg:space-x-[1%] xl:space-x-[2%] 2xl:space-x-[2.5%] w-full h-full divide-y divide-gray-200/30'
                                    >
                                        <li className='navBtn btnTxtSize'>
                                            Home
                                        </li>
                                        <li className='navBtn btnTxtSize'>
                                            About Us
                                        </li>
                                        <li className='navBtn btnTxtSize'>
                                            What We Offer
                                        </li>
                                        <li className='navBtn btnTxtSize'>
                                            Practice Areas
                                        </li>
                                        <li className='navBtn btnTxtSize'>
                                            Our Team
                                        </li>
                                        <li className='navBtn btnTxtSize'>
                                            Client Care
                                        </li>
                                        <li className='navBtn btnTxtSize'>
                                            Professional Indemnity
                                        </li>
                                        <li className='navBtn btnTxtSize'>
                                            Fees &amp; Disbursements
                                        </li>
                                        <li className='navBtn btnTxtSize'>
                                            Contact Us
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>

            </div >
        </div>
    )
}

export default NavLogin